import styled from "@emotion/styled";
import {ReactComponent as icon} from "../../../../images/800CallLogs/Resources for Popup/IconX.svg";

export const XIcon = styled(icon)`
    width: 25px;
    color: #2B2B2B
`;

export const CloseIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    
`;
